<template>
    <edit></edit>
</template>

<script>
    import edit from './moments_topic_edit.vue'

    export default {
        name: 'moments_topic_add',

        components: {
            edit
        }
    }
</script>